export const PATH_HOME = "/home";
export const PATH_CERCA = "/cerca";
export const PATH_MONITORA = "/monitora";
export const PATH_CONTATTI = "/contatti";
export const PATH_FAQ = "/faq";
export const PATH_INFORMATIVA = "/trattamentoDati";
export const PATH_REGIONE = "https://www.regione.liguria.it";
export const PATH_LIGURIA_DIGITALE = "https://www.liguriadigitale.it";
export const PATH_GARANTE_PRIVACY = "https://www.garanteprivacy.it";
// Pagine ospedali
export const PATH_IMPERIA = "https://www.asl1.liguria.it/ospedali/ospedale-imperia.html";
export const PATH_SANREMO = "https://www.asl1.liguria.it/ospedali/ospedale-sanremo.html";
export const PATH_BORDIGHERA = "https://www.asl1.liguria.it/ospedali/ospedale-bordighera.html";
export const PATH_SANTA_CORONA = "https://www.asl2.liguria.it/ospedali/ospedale-pietra-ligure.html";
export const PATH_SANTA_MARIA_MISERICORDIA = "https://www.asl2.liguria.it/ospedali/ospedale-albenga.html";
export const PATH_SAN_GIUSEPPE = "https://www.asl2.liguria.it/ospedali/ospedale-cairo-montenotte.html";
export const PATH_SAN_PAOLO = "https://www.asl2.liguria.it/ospedali/ospedale-savona.html";
export const PATH_LA_COLLETTA = "http://www.asl3.liguria.it/ospedali/la-colletta-arenzano.html";
export const PATH_MICONE = "http://www.asl3.liguria.it/ospedali/micone-sestri-ponente.html";
export const PATH_VILLA_SCASSI = "http://www.asl3.liguria.it/ospedali/villa-scassi-sampierdarena.html";
export const PATH_GALLINO = "http://www.asl3.liguria.it/ospedali/gallino-pontedecimo.html";
export const PATH_RIBOLI = "http://www.asl4.liguria.it/ospedali/ospedale-lavagna";
export const PATH_SESTRI_LEVANTE = "http://www.asl4.liguria.it/ospedali/ospedale-sestri-levante";
export const PATH_MONTALLEGRO = "http://www.asl4.liguria.it/ospedali/ospedale-rapallo";
export const PATH_ASL5 = "http://www.asl5.liguria.it/PerilCittadino/Ospedale.aspx";
export const PATH_GALLIERA = "https://www.galliera.it";
export const PATH_SAN_MARTINO = "https://www.ospedalesanmartino.it";
export const PATH_GASLINI = "https://www.gaslini.org";
export const PATH_EVANGELICO = "http://www.ospedale-evangelico.it";
